﻿import { DrawingService2020 } from '../DrawingService2020.js';
import { BabylonUpdateMaterialImageVisitor, BabylonRenderVisitor } from './BabylonRenderVisitor.js';

/**
 * The BabylonDrawingService primarily implements the interface referenced by the Component/Product
 * classes for updating the drawing (in this case a <canvas> based 3D drawing).
 */
export class BabylonDrawingService extends DrawingService2020 {
  constructor(productDrawing, loadedMaterials, getProductFinishName, scene, onLoadSingleMaterial) {
    super(productDrawing, loadedMaterials, getProductFinishName, onLoadSingleMaterial);
    this.scene = scene;
  }

  /**
   * Used when we're first downloading low-res images, followed by download of the hi-res images.
   */
  refreshMaterialImages(component) {
    if (this.isDrawingUpdatesEnabled) {
      const visitor = new BabylonUpdateMaterialImageVisitor();
      visitor.visit(component);
    }
  }

  createDisplayObject(component) {
    if (this.isDrawingUpdatesEnabled) {
      const visitor = new BabylonRenderVisitor(this.loadedMaterials, this.productDrawing, this.scene);
      this.assignMaterialJitLoaderTo(visitor);
      return visitor.visit(component);
    }
  }

  /**
   * Returns a new display object (depending on the material).
   */
  createMaterialObject(component) {
    return this.createDisplayObject(component);
  }

  /**
   * Creates a light-weight display object whose only purpose is to contain child display objects.
   */
  createContainer(component) {
    return this.createDisplayObject(component);
  }

  /**
   * Adds the display object as a child of the parent display object.
   */
  addToParentDisplayObject(parent, displayObject) {
    if (this.isDrawingUpdatesEnabled && parent && displayObject) {
      displayObject.parent = parent;
      //console.log('Babylon Drawing Service: set displayObject.parent = parent');
    }
  }

  /**
   * Adds the component's display object as a child of the parent component's display object.
   */
  addChildDisplayObject(component) {
    if (component.parent) {
      this.addToParentDisplayObject(component.parent.displayObject, component.displayObject);
    }
  }

  removeChildDisplayObject(displayObject) {
    if (this.isDrawingUpdatesEnabled) {
      if (displayObject.parent) {
        displayObject.parent = null;
        //console.log('Babylon Drawing Service: set displayObject.parent = null');
      } else {
        const index = this.scene.removeMesh(displayObject, true);
        //console.log('Babylon Drawing Service: scene.removeMesh(displayObject)');
      }
      displayObject.dispose();
    }
  }

  performInlineUpdate(component, onInitVisitor) {
    if (this.isDrawingUpdatesEnabled) {
      const visitor = new BabylonRenderVisitor(this.loadedMaterials, this.productDrawing, this.scene);
      visitor.isInlineUpdate = true;
      this.assignMaterialJitLoaderTo(visitor);
      if (onInitVisitor) {
        onInitVisitor(visitor);
      }
      visitor.visit(component);
    }
  }

  //#region Component Labels

  toggleFinishLabels(component, on) {
    // TODO: Implement this
    //const visitor = new HtmlLabelVisitor(on, this.getProductFinishName);
    //visitor.visitRoot(component);
  }

  updateFinishLabel(component) {
    // TODO: Implement this
    //if (HtmlLabelVisitor.isLabelVisible(component)) {
    //  const visitor = new HtmlLabelVisitor(true, this.getProductFinishName);
    //  visitor.visitRoot(component);
    //}
  }

  /**
   * Perform necessary clean up to help the browser's memory management and to avoid leaks.
   */
  detachFinishLabel(component) {
    // TODO: Implement this
    //component.finishLabel = null;
  }

  //#endregion Component Labels

}